// Select the two target elements
const quantitySelector = document.querySelector('[data-block-id="quantity_selector"]');
const buyButtons = document.querySelector('[data-block-id="buy_buttons"]');

// Check that both elements exist
if (quantitySelector && buyButtons) {
  // Create a wrapper div with the desired class
  const wrapper = document.createElement('div');
  wrapper.className = 'qty_atc_wrapper';

  // Insert the wrapper before the first element
  quantitySelector.parentNode.insertBefore(wrapper, quantitySelector);

  // Move both target elements into the wrapper
  wrapper.appendChild(quantitySelector);
  wrapper.appendChild(buyButtons);
}
